<template>
  <DModal
    :show-close="false"
    :isBgOverlay="true"
    @close="$emit('close')"
    :appendToBody="true"
    style="z-index: 12312312312312"
  >
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2 v-if="isEditing">Redigér stillingskategori</h2>
        <h2 v-else>Opret ny stillingskategori</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="d-input-group">
          <label class="d-label">Titel</label>
          <input
            type="text"
            class="d-input"
            v-model="title"
            ref="input_title"
            placeholder="F.eks. Lærer"
          >
        </div>

        <div class="uv-limit-box" v-if="!forceHourLimitMode && !hasHourLimit">
          <div
            class="d-input-group d-input-group--toggler uv-limit-box__toggle"
            :class="{'d-input-group--toggler--active': localManualSalary}"
            @click.stop="setIsManualSalary(!localManualSalary)"
          >
            <label class="d-label">Skal indberettes som vikarløn</label>
            <AppToggle :allowChanges="false" :propOn="localManualSalary"/>
          </div>

          <!-- Vises kun når vikarløn er slået til -->
          <div class="uv-limit-box__fields" v-if="localManualSalary">
            <div class="d-input-group-flex">
              <div>
                <label class="d-label">Standard lønkode</label>
                <select class="do-select width-100" v-model="salaryCodeId">
                  <option disabled value=""></option>
                  <option
                    v-for="salaryCode in salaryCodes"
                    :key="salaryCode.id"
                    :value="salaryCode.id"
                  >
                    {{ salaryCodeLabel(salaryCode) }}
                  </option>
                </select>
              </div>

              <div v-if="costCenters.length > 0">
                <label class="d-label">Standard omkostningsted</label>
                <select class="do-select width-100" v-model="omkostningssted">
                  <option disabled value=""></option>
                  <option v-for="costCenter in costCenters" :key="costCenter.code" :value="costCenter.code">
                    {{ costCenter.title }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="uv-limit-box" v-if="!localManualSalary">
          <div
            class="d-input-group d-input-group--toggler uv-limit-box__toggle"
            :class="{'d-input-group--toggler--active': hasHourLimit}"
            @click.stop="toggleHasHourLimit"
          >
            <label class="d-label">Sæt UV-grænse (§ 5, stk. 2)</label>
            <AppToggle :allowChanges="false" :propOn="hasHourLimit"/>
          </div>

          <div class="uv-limit-box__fields" v-if="hasHourLimit">
            <div class="d-input-group-flex">
              <div>
                <label class="d-label">UV-grænse</label>
                <input
                  type="number"
                  min="0"
                  step="1"
                  class="d-input width-100"
                  v-model="hourLimit"
                  ref="input_hour_limit"
                  placeholder="F.eks. 750"
                >
              </div>

              <div>
                <label class="d-label">Lønkode over UV-grænse</label>
                <select class="do-select width-100" v-model="hourLimitSalaryCodeId">
                  <option disabled value=""></option>
                  <option
                    v-for="salaryCode in salaryCodes"
                    :key="salaryCode.id"
                    :value="salaryCode.id"
                  >
                    {{ salaryCodeLabel(salaryCode) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="uv-limit-box" v-if="!localManualSalary && hasSpecialSalaryCode && !isSalarySystemSD">
          <div
            class="d-input-group d-input-group--toggler uv-limit-box__toggle"
            :class="{'d-input-group--toggler--active': hasSpecialHourLimit}"
            @click.stop="toggleHasSpecialHourLimit"
          >
            <label class="d-label">Specialskole uv-tillæg (§ 5, stk. 4)</label>
            <AppToggle :allowChanges="false" :propOn="hasSpecialHourLimit"/>
          </div>

          <div class="uv-limit-box__fields" v-if="hasSpecialHourLimit">
            <div class="d-input-group-flex">
              <div>
                <label class="d-label">Lønkode spec-skole UV-tillæg</label>
                <select class="do-select width-100" v-model="specialHourLimitSalaryCodeId">
                  <option value=""></option>
                  <option
                    v-for="salaryCode in salaryCodes"
                    :key="salaryCode.id"
                    :value="salaryCode.id"
                  >
                    {{ salaryCodeLabel(salaryCode) }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="uv-limit-box" v-if="isSalarySystemSD">
          <div
            class="d-input-group d-input-group--toggler uv-limit-box__toggle"
            :class="{'d-input-group--toggler--active': enableEmploymentDecimal}"
            @click.stop="enableEmploymentDecimal = !enableEmploymentDecimal"
          >
            <label class="d-label">Indsend lønbrøk</label>
            <AppToggle :allowChanges="false" :propOn="enableEmploymentDecimal"/>
          </div>
        </div>
      </div>

      <div class="d-modal__buttons">
        <div>
          <template v-if="isEditing">
            <button
              class="do-bttn"
              :class="{
                'do-bttn--submit--loading': isDeleting,
                'do-bttn--delete-confirm': confirmingDelete,
                'do-bttn--delete-disabled': isTemplateInUse || isLoadingUsage
              }"
              :content="deleteButtonTitle"
              v-tippy="{
                arrow: true,
                placement: 'top',
                animateFill: false,
                animation: 'shift-away',
                boundary: 'window',
                zIndex: 12312312312312
              }"
              @click="onDeleteClick"
            >
              <span v-if="confirmingDelete">Bekræft sletning</span>
              <span v-else class="icon-bin"></span>
            </button>
            <button
              v-if="confirmingDelete && !isDeleting"
              class="delete-cancel"
              @click="confirmingDelete = false"
            >
              Fortryd
            </button>
          </template>
        </div>
        <div>
          <button class="do-bttn" @click="$emit('close')">
            {{ $t('vue2.common.cancel') }}
          </button>
          <button
            class="do-bttn do-bttn--submit"
            :class="{
              'do-bttn--submit--disabled': !isValid || isSubmitting,
              'do-bttn--submit--loading': isSubmitting
            }"
            @click="onSubmit"
          >
            {{ isEditing ? 'Opdatér' : 'Opret' }}
          </button>
        </div>
      </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
import AppToggle from '../../common/AppToggle.vue'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'

export default {
  components: {AppToggle, DModal},
  props: {
    theEditEmploymentTemplate: {
      type: Object,
      default: null
    },
    forceHourLimitMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: '',
      localManualSalary: false,
      salaryCodeId: null,
      omkostningssted: null,
      hasHourLimit: false,
      hourLimit: null,
      hourLimitSalaryCodeId: null,
      hasSpecialHourLimit: false,
      specialHourLimitSalaryCodeId: null,
      enableEmploymentDecimal: false,
      isSubmitting: false,
      isDeleting: false,
      confirmingDelete: false
    }
  },
  computed: {
    isEditing () {
      return !!this.theEditEmploymentTemplate
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    templateId () {
      return this.isEditing ? this.theEditEmploymentTemplate.id : null
    },
    isValid () {
      return this.title.trim().length > 0
    },
    costCenters () {
      return this.$store.getters.costCenters
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted
    },
    isSalarySystemSD () {
      return this.$store.getters.salarySystem === 'SD'
    },
    // KMD: lønart 8411. SD: tillægsnummer 160099/160100 eller lønart 836.
    hasSpecialSalaryCode () {
      if (this.$store.getters.salarySystem === 'SD') {
        return (this.salaryCodes || []).some(salaryCode =>
          String(salaryCode.tillaegsnummer) === '160099' ||
          String(salaryCode.tillaegsnummer) === '160100' ||
          String(salaryCode.loenart) === '836')
      }
      return (this.salaryCodes || []).some(salaryCode => String(salaryCode.loenart) === '8411' || String(salaryCode.code) === '8411')
    },
    isLoadingUsage () {
      return this.$store.state.employments.isLoadingEmploymentsTypesForSchool
    },
    // Antal (ikke-slettede) ansættelser der peger på denne stillingskategori.
    // Sletning blokeres så længe kategorien er i brug, da employment_template_id
    // ellers ville stå tilbage som et forældreløst id på ansættelserne.
    templateUsageCount () {
      if (!this.isEditing) return 0
      const employments = this.$store.state.employments.employments || []
      let count = 0
      for (let i = 0; i < employments.length; i++) {
        const emp = employments[i]
        if (emp.deleted) continue
        if (emp.employment_template_id == null) continue
        if (Number(emp.employment_template_id) === Number(this.templateId)) count++
      }
      return count
    },
    isTemplateInUse () {
      return this.templateUsageCount > 0
    },
    deleteButtonTitle () {
      if (this.isLoadingUsage) return 'Undersøger om kategorien er i brug…'
      if (this.isTemplateInUse) {
        return 'Bruges af ' + this.templateUsageCount +
          (this.templateUsageCount === 1 ? ' ansættelse' : ' ansættelser') +
          ' og kan ikke slettes'
      }
      if (this.confirmingDelete) return 'Klik for at bekræfte sletning'
      return 'Slet stillingskategori'
    }
  },
  methods: {
    // Ved SD vises "tillægsnummer-lønart navn" (vSupplementTitle), så lønkoden kan identificeres
    // entydigt på tillægsnummeret; ellers (KMD) vises "navn (lønart)".
    salaryCodeLabel (salaryCode) {
      if (this.isSalarySystemSD) {
        return salaryCode.vSupplementTitle || (salaryCode.name + ' (' + salaryCode.code + ')')
      }
      return salaryCode.name + ' (' + salaryCode.code + ')'
    },
    setIsManualSalary (bool) {
      this.localManualSalary = bool
      if (bool) {
        this.resetHourLimitFields()
      } else {
        this.resetManualFields()
      }
    },
    resetManualFields () {
      this.salaryCodeId = null
      this.omkostningssted = null
    },
    toggleHasHourLimit () {
      if (this.forceHourLimitMode) return
      this.setHasHourLimit(!this.hasHourLimit)
    },
    setHasHourLimit (bool) {
      this.hasHourLimit = bool
      if (!bool) {
        this.resetHourLimitFields()
      } else {
        this.$nextTick(() => {
          const el = this.$refs.input_hour_limit
          if (el) el.focus()
        })
      }
    },
    toggleHasSpecialHourLimit () {
      this.setHasSpecialHourLimit(!this.hasSpecialHourLimit)
    },
    setHasSpecialHourLimit (bool) {
      this.hasSpecialHourLimit = bool
      if (!bool) {
        this.specialHourLimitSalaryCodeId = null
      }
    },
    resetHourLimitFields () {
      this.hasHourLimit = false
      this.hourLimit = null
      this.hourLimitSalaryCodeId = null
      this.hasSpecialHourLimit = false
      this.specialHourLimitSalaryCodeId = null
    },
    onSubmit () {
      if (!this.isValid || this.isSubmitting) return

      this.isSubmitting = true

      const onSuccess = (response) => {
        this.isSubmitting = false
        if (response.status === 'error') {
          eventbus.toast = {text: response.message, 'success': false}
          return
        }
        if (this.isEditing) {
          console.log('child-emit')
          this.$emit('updated', response)
        } else {
          this.$emit('created', response)
        }
        this.$emit('close')
      }

      const onFailure = () => {
        this.isSubmitting = false
      }

      // her håndteres null / number korrekt
      const salaryCodeValue = this.salaryCodeId ? Number(this.salaryCodeId) : null
      const omkostningsstedValue = this.omkostningssted ? String(this.omkostningssted) : null
      const hourLimitValue = !this.localManualSalary && this.hasHourLimit && this.hourLimit ? Number(this.hourLimit) : null
      const hourLimitSalaryCodeValue = !this.localManualSalary && this.hasHourLimit && this.hourLimitSalaryCodeId ? Number(this.hourLimitSalaryCodeId) : null
      const specialHourLimitSalaryCodeValue = !this.localManualSalary && this.hasSpecialHourLimit && this.specialHourLimitSalaryCodeId ? Number(this.specialHourLimitSalaryCodeId) : null
      const enableEmploymentDecimalValue = this.isSalarySystemSD ? this.enableEmploymentDecimal : false

      if (this.isEditing) {
        docendo.updateEmploymentTemplate(
          this.schoolId,
          this.templateId,
          this.title.trim(),
          this.localManualSalary,
          salaryCodeValue,
          omkostningsstedValue,
          hourLimitValue,
          hourLimitSalaryCodeValue,
          specialHourLimitSalaryCodeValue,
          enableEmploymentDecimalValue,
          onSuccess,
          onFailure
        )
      } else {
        docendo.createEmploymentTemplate(
          this.schoolId,
          this.title.trim(),
          this.localManualSalary,
          salaryCodeValue,
          omkostningsstedValue,
          hourLimitValue,
          hourLimitSalaryCodeValue,
          specialHourLimitSalaryCodeValue,
          enableEmploymentDecimalValue,
          onSuccess,
          onFailure
        )
      }
    },

    onDeleteClick () {
      if (this.isDeleting || this.isTemplateInUse || this.isLoadingUsage) return
      if (!this.confirmingDelete) {
        this.confirmingDelete = true
        return
      }
      this.deleteEmploymentTemplate()
    },

    deleteEmploymentTemplate () {
      if (!this.isEditing || this.isDeleting) return
      this.isDeleting = true

      const onSuccess = (response) => {
        if (response.status === 'error') {
          eventbus.toast = {text: response.message, 'success': false}
        }
        this.isDeleting = false
        this.$emit('deleted', response)
        this.$emit('close')
      }

      const onFailure = (error) => {
        this.isDeleting = false
        console.log('deleteEmploymentTemplate failed', error)
      }

      docendo.deleteEmploymentTemplate(
        this.schoolId,
        this.templateId,
        onSuccess,
        onFailure
      )
    }
  },
  beforeMount () {
    if (this.theEditEmploymentTemplate) {
      const t = this.theEditEmploymentTemplate
      this.title = t.title || ''
      this.salaryCodeId = typeof t.salary_code_id !== 'undefined' && t.salary_code_id !== null ? String(t.salary_code_id) : ''
      this.omkostningssted = typeof t.omkostningssted !== 'undefined' && t.omkostningssted !== null ? String(t.omkostningssted) : ''
      this.hourLimit = typeof t.hour_limit !== 'undefined' && t.hour_limit !== null ? String(t.hour_limit) : ''
      this.hourLimitSalaryCodeId = typeof t.hour_limit_salary_code_id !== 'undefined' && t.hour_limit_salary_code_id !== null ? String(t.hour_limit_salary_code_id) : ''
      this.specialHourLimitSalaryCodeId = typeof t.special_hour_limit_salary_code_id !== 'undefined' && t.special_hour_limit_salary_code_id !== null ? String(t.special_hour_limit_salary_code_id) : ''
      this.hasSpecialHourLimit = !!this.specialHourLimitSalaryCodeId
      this.hasHourLimit = !!(this.hourLimit || this.hourLimitSalaryCodeId || this.specialHourLimitSalaryCodeId)
      this.localManualSalary = !!t.manual_salary
      this.enableEmploymentDecimal = !!t.enable_employment_decimal
    }
    if (this.forceHourLimitMode) {
      this.localManualSalary = false
      this.resetManualFields()
      this.hasHourLimit = true
    }
  },
  mounted () {
    // Hent ansættelser, så vi kan afgøre om kategorien er i brug, før den kan slettes.
    if (this.isEditing) {
      this.$store.dispatch('readEmployments')
    }
    this.$nextTick(_ => {
      const el = this.$refs.input_title
      if (el) el.focus()
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 500px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
}

.d-modal__buttons > div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-bttn--delete-confirm {
  background: #dc2626;
  border-color: #dc2626;
  color: #fff;
}

.do-bttn--delete-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.delete-cancel {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  font-size: 13px;
  text-decoration: underline;
}

.d-modal__content {
  padding: 1rem;
}

.d-input-group {
  margin: 0;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.uv-limit-box {
  background: #fff;
  border-radius: 4px;
  margin-bottom: 1rem;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
  border: 1px solid #e2e8f0;
}

.d-input-group.uv-limit-box__toggle {
  margin-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  padding: 1rem;
}

.uv-limit-box__fields {
  padding: 1rem 0;
  border-top: 1px solid #e5e7eb;
  background: #f6f9fc;
}

.uv-limit-box__fields .d-input-group-flex {
  margin-bottom: 0;
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group {
  margin-bottom: 1rem;
}

.d-input-group-flex {
  display: flex;
  padding: 0 1rem;
  gap: 1rem;
}

.d-input-group-flex > div {
  flex: 1;
}

.d-input-group-flex label.d-label {
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// DoEmploymentTemplate.vue?87bab6b6